import { i18n } from "@/utils/i18n";
import storage from "@/utils/storage";
import { create } from "zustand";

interface State {
    locale: "sv" | "en";
}

interface Actions {
    setLocale(locale: "sv" | "en"): void;
}

const useLocale = create<State & Actions>(set => ({
    locale: storage.getItem("locale") ?? "sv",
    setLocale: locale => {
        i18n.locale = locale;
        set({ locale });
        storage.setItem("locale", locale);
    },
}));

export default useLocale;
